export interface IGetTCRequest {
    tcVersion: string;
}

export class GetTCRequest implements IGetTCRequest {
    public tcVersion: string;
    
    constructor(tcVersion: string){
        this.tcVersion = tcVersion;
    }
}